import React from 'react';
import {
  Alert, Card, CardContent, Typography, FormControl, InputLabel, Select,
  MenuItem, OutlinedInput, Checkbox, ListItemText, TextField, Autocomplete, Box, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { getCategorias, getMateriais } from "../helpers";

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 48 * 4.5 + 8,
      width: 'auto',
    },
  },
};

const OPCOES_PROMOCAO = ["Mês", "Outlet", "Mix", "Linha"];
const OPCOES_ON_HOLD = ['Sim', 'Não'];
const OPCOES_MARCA = ['Wolff', 'Lyor'];
const OPTIONS_FIND_CLIENT = [
  { value: 'todos', description: 'Código/Cnpj/Nome' },
  { value: 'codigo', description: 'Código' },
  { value: 'cnpj', description: 'CNPJ' },
  { value: 'nome', description: 'Nome' },
];
const UFS = [
  ['AC', 'Acre'], ['AL', 'Alagoas'], ['AP', 'Amapá'], ['AM', 'Amazonas'], ['BA', 'Bahia'], ['CE', 'Ceará'],
  ['DF', 'Distrito Federal'], ['ES', 'Espírito Santo'], ['GO', 'Goiás'], ['MA', 'Maranhão'], ['MT', 'Mato Grosso'],
  ['MS', 'Mato Grosso do Sul'], ['MG', 'Minas Gerais'], ['PA', 'Pará'], ['PB', 'Paraíba'], ['PR', 'Paraná'],
  ['PE', 'Pernambuco'], ['PI', 'Piauí'], ['RJ', 'Rio de Janeiro'], ['RN', 'Rio Grande do Norte'], ['RS', 'Rio Grande do Sul'],
  ['RO', 'Rondônia'], ['RR', 'Roraima'], ['SC', 'Santa Catarina'], ['SP', 'São Paulo'], ['SE', 'Sergipe'], ['TO', 'Tocantins']
];
const LISTA_REGIME = [
  { id: 1, value: 'Simples Nacional (Exclusivo p/ micro e pequenas empresas)' },
  { id: 3, value: 'Regime Normal (Empresas com o Lucro Real ou Presumido)' }
] as const;

interface FiltrosGeracaoProps {
  filtro: any;
  setFiltro: React.Dispatch<React.SetStateAction<any>>;
  busca_por: any;
  set_busca_por: (val: any) => void;
  clientList: any[];
  client: any;
  inputClient: string;
  setInputClient: (val: string) => void;
  handleChangeClient: (val: any) => void;
  loadingFindClient: boolean;
  discount: string;
  setDiscount: (val: string) => void;
  codeProduct: string;
  setCodeProduct: (val: string) => void;
  onEnterCodeProduct: () => void;
  mask_cgc: (val: string) => string;
  handleDisabledFieldClick: (msg: string) => void;
}

const FiltrosGeracao: React.FC<FiltrosGeracaoProps> = (props) => {
  const {
    filtro, setFiltro, busca_por, set_busca_por, clientList, client,
    inputClient, setInputClient, handleChangeClient, loadingFindClient,
    mask_cgc, handleDisabledFieldClick, discount, setDiscount, codeProduct, setCodeProduct, onEnterCodeProduct
  } = props;
  const [tipoConsulta, setTipoConsulta] = React.useState<'cliente' | 'uf'>('cliente');

  const opcoesCategoria = getCategorias();
  const opcoesMaterial = getMateriais();
  const msgErro = "Por favor, escolha apenas uma opção para a busca: utilize os filtros em 'Outros Filtros' ou preencha o campo 'Geração de Dados'";

  const isItensPreenchidos = discount !== "" || codeProduct !== "";
  const isFiltroPreenchido = (
    filtro.promocao.length > 0 || filtro.onHold.length > 0 ||
    filtro.categoria.length > 0 || filtro.material.length > 0 ||
    filtro.marca.length > 0 || !!(filtro.qtdEstoque && filtro.qtdEstoque !== "")
  );

  const handleTipoConsulta = (_: React.MouseEvent<HTMLElement>, novoTipo: 'cliente' | 'uf' | null) => {
    if (!novoTipo || novoTipo === tipoConsulta) return;

    setTipoConsulta(novoTipo);
    if (novoTipo === 'uf') {
      setInputClient('');
      handleChangeClient(null);
      return;
    }

    setFiltro((prev: any) => ({ ...prev, sigUfs: undefined, cgcCpfCliente: undefined }));
  };

  return (
    <>
      <Card sx={{ minWidth: 275, backgroundColor: '#1a3661', marginBottom: '2%' }}>
        <CardContent className="cardContent">
          <div><Typography gutterBottom className="cardTitle">Outros Filtros</Typography></div>
          <div className="cardInfo">
            {/* Promoção */}
            <FormControl style={{ width: '16%' }}>
              <InputLabel>Tipo de Promoção</InputLabel>
              <Select
                multiple value={filtro.promocao}
                onChange={e => setFiltro((prev: any) => ({ ...prev, promocao: e.target.value }))}
                renderValue={(s: any) => s.join(', ')}
                input={<OutlinedInput label="Tipo de Promoção" />}
                MenuProps={MenuProps}
                disabled={isItensPreenchidos}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              >
                {OPCOES_PROMOCAO.map((p) => (
                  <MenuItem key={p} value={p}>
                    <Checkbox checked={filtro.promocao.includes(p)} /><ListItemText primary={p} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* On Hold */}
            <FormControl style={{ width: '16%' }}>
              <InputLabel>On Hold</InputLabel>
              <Select
                multiple value={filtro.onHold}
                onChange={e => setFiltro((prev: any) => ({ ...prev, onHold: e.target.value }))}
                renderValue={(s: any) => s.join(', ')}
                input={<OutlinedInput label="On Hold" />}
                MenuProps={MenuProps}
                disabled={isItensPreenchidos}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              >
                {OPCOES_ON_HOLD.map((o) => (
                  <MenuItem key={o} value={o}>
                    <Checkbox checked={filtro.onHold.includes(o)} /><ListItemText primary={o} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Material */}
            <FormControl style={{ width: '16%' }}>
              <InputLabel>Material</InputLabel>
              <Select
                multiple value={filtro.material}
                onChange={e => setFiltro((prev: any) => ({ ...prev, material: Array.isArray(e.target.value) ? e.target.value : [e.target.value] }))}
                renderValue={(selected: any[]) => selected.map(k => opcoesMaterial.find((m: any) => m.keynam === k)?.valkey).join(', ')}
                input={<OutlinedInput label="Material" />}
                MenuProps={MenuProps}
                disabled={isItensPreenchidos}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              >
                {opcoesMaterial.map((m: any) => (
                  <MenuItem key={m.keynam} value={m.keynam}>
                    <Checkbox checked={filtro.material.includes(m.keynam)} /><ListItemText primary={m.valkey} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Marca */}
            <FormControl style={{ width: '16%' }}>
              <InputLabel>Marca</InputLabel>
              <Select
                multiple value={filtro.marca}
                onChange={e => setFiltro((prev: any) => ({ ...prev, marca: e.target.value }))}
                renderValue={(s: any) => s.join(', ')}
                input={<OutlinedInput label="Marca" />}
                MenuProps={MenuProps}
                disabled={isItensPreenchidos}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              >
                {OPCOES_MARCA.map((m) => (
                  <MenuItem key={m} value={m}>
                    <Checkbox checked={filtro.marca.includes(m)} /><ListItemText primary={m} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* Estoque e Quantidade */}
            <FormControl style={{ width: '16%' }}>
              <InputLabel>Estoque</InputLabel>
              <Select
                value={filtro.estoque}
                onChange={e => setFiltro((p: any) => ({ ...p, estoque: e.target.value }))}
                label="Estoque"
                disabled={isItensPreenchidos}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              >
                <MenuItem value='='>Igual</MenuItem>
                <MenuItem value='!='>Diferente</MenuItem>
                <MenuItem value='>'>Maior que</MenuItem>
                <MenuItem value='>='>Maior ou igual que</MenuItem>
                <MenuItem value='<'>Menor que</MenuItem>
                <MenuItem value='<='>Menor ou igual que</MenuItem>
              </Select>
            </FormControl>

            <FormControl style={{ width: '16%', flex: 1 }}>
              <TextField
                label="Quantidade"
                variant="outlined"
                value={filtro.qtdEstoque}
                onChange={e => setFiltro((p: any) => ({ ...p, qtdEstoque: e.target.value }))}
                disabled={isItensPreenchidos}
                slotProps={{ inputLabel: { shrink: true } }}
                onClick={() => isItensPreenchidos && handleDisabledFieldClick(msgErro)}
              />
            </FormControl>

            {/* Cliente ou UF */}
            <FormControl style={{ width: '100%', paddingRight: 0 }}>
              <Box sx={{ p: 2, border: '1px solid #dbe4ef', borderRadius: 2, bgcolor: '#f8fafc' }}>
                <Typography fontWeight={700} color="#1a3661">Consulta por destino</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25, mb: 1.5 }}>
                  Escolha Cliente ou UF para consultar os impostos dos produtos.
                </Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, alignItems: 'center' }}>
                  <ToggleButtonGroup
                    exclusive
                    value={tipoConsulta}
                    onChange={handleTipoConsulta}
                    size="small"
                    color="primary"
                    sx={{ height: 56 }}
                  >
                    <ToggleButton value="cliente" sx={{ textTransform: 'none', gap: 0.75, minWidth: 108 }}>
                      <PersonSearchIcon fontSize="small" /> Cliente
                    </ToggleButton>
                    <ToggleButton value="uf" sx={{ textTransform: 'none', gap: 0.75, minWidth: 88 }}>
                      <LocationOnOutlinedIcon fontSize="small" /> UF
                    </ToggleButton>
                  </ToggleButtonGroup>

                  {tipoConsulta === 'cliente' ? (
                    <Box sx={{ display: 'flex', flex: '1 1 600px', gap: 1, minWidth: 0 }}>
                      <Autocomplete
                        options={OPTIONS_FIND_CLIENT}
                        onChange={(_, val) => set_busca_por(val)}
                        getOptionLabel={(o) => o.description}
                        value={busca_por}
                        renderInput={(p) => <TextField {...p} label="Buscar cliente por" variant="outlined" />}
                        sx={{ minWidth: 185, flex: '0 1 220px' }}
                      />
                      <Autocomplete
                        loading={loadingFindClient}
                        sx={{ flex: 1, minWidth: 260 }}
                        options={clientList}
                        filterOptions={(options) => options}
                        value={client}
                        onInputChange={(_, val) => setInputClient(val)}
                        onChange={(_, val) => handleChangeClient(val)}
                        getOptionLabel={(o: any) => !!o.nomCli ? `${o.nomCli} - ${mask_cgc(o?.cgcCpf || '')}` : ''}
                        renderInput={(p) => <TextField {...p} label="Razão Social" variant="outlined" slotProps={{ inputLabel: { shrink: true } }} />}
                      />
                    </Box>
                  ) : (
                    <FormControl sx={{ flex: '1 1 320px', minWidth: 240 }}>
                      <InputLabel id="uf-consulta-label">UF de destino</InputLabel>
                      <Select
                        labelId="uf-consulta-label"
                        label="UF de destino"
                        value={filtro.sigUfs || ''}
                        onChange={(event) => setFiltro((prev: any) => ({ ...prev, sigUfs: event.target.value }))}
                      >
                        {UFS.map(([sigla, nome]) => <MenuItem key={sigla} value={sigla}>{sigla} — {nome}</MenuItem>)}
                      </Select>
                    </FormControl>
                  )}
                  {tipoConsulta === 'uf' && (
                    <FormControl sx={{ flex: '1 1 330px', minWidth: 280 }}>
                      <InputLabel id="regime-tributario-label">Regime tributário</InputLabel>
                      <Select
                        labelId="regime-tributario-label"
                        label="Regime tributário"
                        value={filtro.regimeTributario ?? 3}
                        onChange={(event) => setFiltro((prev: any) => ({ ...prev, regimeTributario: Number(event.target.value) as 1 | 3 }))}
                        renderValue={(value) => LISTA_REGIME.find((regime) => regime.id === value)?.value || ''}
                      >
                        {LISTA_REGIME.map((regime) => (
                          <MenuItem key={regime.id} value={regime.id}>{regime.value}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </Box>
                {tipoConsulta === 'uf' && (
                  <Alert severity="warning" sx={{ mt: 1.5 }}>
                    Os valores de impostos exibidos quando a consulta é feita por UF são estimativas. Para obter valores mais precisos, faça a busca por cliente.
                  </Alert>
                )}
              </Box>
            </FormControl>
          </div>
        </CardContent>
      </Card>

      <Card sx={{ minWidth: 275, backgroundColor: '#1a3661', marginBottom: '2%' }}>
        <CardContent className="cardContent">
          <div><Typography gutterBottom className="cardTitle">Geração de Dados</Typography></div>
          <div className="cardInfo">
            <TextField
              label="Digite o Código do Produto"
              variant="outlined"
              sx={{ width: '80% !important', marginRight: '8px' }}
              value={codeProduct}
              onChange={e => setCodeProduct(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter' && !e.nativeEvent.isComposing) {
                  e.preventDefault();
                  onEnterCodeProduct();
                }
              }}
              disabled={isFiltroPreenchido}
              slotProps={{ inputLabel: { shrink: true } }}
              onClick={() => isFiltroPreenchido && handleDisabledFieldClick(msgErro)}
            />
            <TextField
              label="% Desconto"
              variant="outlined"
              sx={{ width: '16%', flex: 1 }}
              value={discount}
              onChange={e => {
                let value = e.target.value;
                value = value.replace(',', '.');
                if (value === '' || /^\d*\.?\d*$/.test(value)) {
                  setDiscount(value);
                }
              }}
              inputProps={{ inputMode: 'decimal' }}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default FiltrosGeracao;
